import { useState, useEffect, ReactElement } from 'react';

import { BrowserRouter,Route, Routes, Navigate } from 'react-router-dom';

// Import components

import Footer from './components/footer/Footer.jsx';
import Header from './components/header/Header.jsx';
import Index from './components/index/Index.jsx';
import LoginForm from './components/login/LoginForm.jsx';
import { MenuContext } from './components/menu/MenuContext.jsx';
import QuestionaryStepForm from './components/questionary/QuestionaryStepForm.jsx';
import ClientQuestionaryStepForm from './components/clientQuestionary/ClientQuestionaryStepForm.jsx';
import RegistrationForm from './components/registration/RegistrationForm.jsx';
import ClientRegistrationForm from './components/clientRegistration/ClientRegistrationForm.jsx';
import Sidebar from './components/sidebar/Sidebar.jsx';
import NoPage from './pages/404Page.jsx'
import ClientsPage from './pages/profile/ClientsPage.jsx';
import EducationPage from './pages/profile/EducationPage.jsx';
import { JazzContainer } from './pages/profile/JazzContainer';
import OrganizationsPage from './pages/profile/OrganizationsPage.jsx';
import OtherPage from './pages/profile/OtherPage.jsx';
import ProfilePage from './pages/profile/ProfilePage.jsx';
import SchedulePage from './pages/profile/SchedulePage.jsx';
import ScheduleSetPage from './pages/profile/ScheduleSetPage.jsx';
import StatisticPage from './pages/profile/StatisticPage.jsx';
import SessionsComponent from './components/sessions/SessionsComponent.jsx';
import ClientSessionsComponent from './components/clientSessions/ClientSessionsComponent.jsx';

function App(): ReactElement {
  const [userRole, setUserRole] = useState<number>(0);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const [isCheckingLogin, setIsCheckingLogin] = useState<boolean>(true);

  const checkLoginStatus = async () => {
    try {
      const response = await fetch('https://meetmind.ru/v1/auth/check-login', {
        method: 'GET',
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        if (data.is_login) {
          setIsLogin(true);
          setUserRole(data.role)
          sessionStorage.setItem("meetmindUserRole", data.role);
        }
      } else {
        console.log('Пользователь не авторизован');
      }
    } catch (error) {
      console.error('Ошибка при проверке авторизации:', error);
    } finally {
      setIsCheckingLogin(false);
    }
  };

  useEffect(() => {
    checkLoginStatus();
  }, []);

  const toggleMenuMobile = () => {
    setMenuOpen(!isMenuOpen);
  };

  if (isCheckingLogin) {
    return <div>Проверка авторизации...</div>;
  }

  return (
    <MenuContext.Provider value={{ isMenuOpen, toggleMenuMobile }}>
      <BrowserRouter>
        <div className="wrapper">
          <Header />
          <main className="main">
            {isLogin && <Sidebar />}
            <div className="main__content">
              <div className="main__container container">
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="login" element={<LoginForm />} />
                  <Route path="/client-registration/:link" element={<ClientRegistrationForm />} />
                  <Route path="/client-questionary" element={<ClientQuestionaryStepForm />} />
                  <Route path="/registration">
                    <Route index element={<RegistrationForm />} />
                    <Route path="questionary" element={<QuestionaryStepForm />} />
                  </Route>
                  <Route
                    path="/sessions"
                    element={isLogin && userRole===1 ? <SessionsComponent /> : <Navigate to="/login" />}
                  />
                  <Route
                    path="/my-sessions"
                    element={isLogin && userRole===2 ? <ClientSessionsComponent /> : <Navigate to="/login" />}
                  />
                  <Route path="/profile">
                    <Route
                      index
                      element={isLogin ? <ProfilePage /> : <Navigate to="/login" />}
                    />
                    <Route
                      path="other"
                      element={isLogin && userRole===1 ? <OtherPage /> : <Navigate to="/login" />}
                    />
                    <Route
                      path="organizations"
                      element={isLogin && userRole===1 ? <OrganizationsPage /> : <Navigate to="/login" />}
                    />
                    <Route
                      path="education"
                      element={isLogin && userRole===1 ? <EducationPage /> : <Navigate to="/login" />}
                    />
                  </Route>
                  <Route
                    path="/schedule"
                    element={isLogin && userRole===1 ? <SchedulePage /> : <Navigate to="/login" />}
                  />
                   <Route
                    path="/schedule-set"
                    element={isLogin && userRole===1 ? <ScheduleSetPage /> : <Navigate to="/login" />}
                  />
                  <Route
                    path="/clients"
                    element={isLogin && userRole===1 ? <ClientsPage /> : <Navigate to="/login" />}
                  />
                  <Route
                    path="/statistics"
                    element={isLogin && userRole===1 ? <StatisticPage /> : <Navigate to="/login" />}
                  />
                   <Route
                    path="/*"
                    element={<NoPage/>}
                  />
                </Routes>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </MenuContext.Provider>
  );
}

export default App;